import { makeStyles } from 'tss-react/mui';
import { spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    contentInner: {
        width: '100%',
        margin: spacing.large,
        [theme.breakpoints.between('sm', 'lg')]: {
            marginBottom: '56px',
        },
        [theme.breakpoints.up('md')]: {
            margin: spacing.xxl,
        },
        [theme.breakpoints.up('xl')]: {
            margin: '128px',
        },
    },
    citationMessage: {
        marginBottom: '20px',
    },
    squareVideoContainer: {
        paddingTop: 0,
        '& > div': {
            position: 'unset',
        },
    },
    quotationMarkStart: {
        transform: 'scaleX(-1)',
        top: '30px',
        left: spacing.large,
        [theme.breakpoints.up('md')]: { top: '61px', left: '73px' },
    },
    quotationMarkEnd: {
        right: '26px',
        bottom: spacing.medium,
        [theme.breakpoints.up('md')]: {
            right: spacing.xxl,
            bottom: '69px',
        },
    },
    quoteContainer: {
        position: 'relative',
    },
    contentWithQuotationMarks: {
        [`& .${classes.contentInner}`]: {
            marginTop: spacing.xl,
            marginBottom: spacing.xl,
            [theme.breakpoints.up('md')]: {
                marginTop: '116px',
                marginBottom: '116px',
            },
        },
    },
    citation: Object.assign(Object.assign({}, theme.typographySpacing.none), { fontStyle: 'italic' }),
    content: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            height: '100%',
        },
    },
    imageSpacer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            width: '50%',
        },
    },
    textLeft: {
        textAlign: 'left',
    },
    textRight: {
        textAlign: 'right',
    },
    textCenter: {
        textAlign: 'center',
    },
    message: {
        '& p, & div,': Object.assign(Object.assign(Object.assign({}, (_params.pageType === 'blog' ? theme.typography.small_bold : theme.typography.small_regular)), theme.typographySpacing.small_regular_sm), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.small_regular_lg) }),
    },
    positionBottom: {
        alignItems: 'end',
        alignSelf: 'end',
    },
    positionTop: {
        alignItems: 'start',
        alignSelf: 'start',
    },
    positionCenter: {
        alignItems: 'center',
        alignSelf: 'center',
    },
    subheading: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.none), { textAlign: 'center', color: colors.supplementary.white, margin: `${spacing.xxs} ${spacing.small}`, [theme.breakpoints.up('sm')]: {
            display: 'block',
            textAlign: 'left',
            margin: 0,
            marginBottom: spacing.medium,
            color: colors.black[700],
        }, [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.none), { marginBottom: spacing.medium }), [theme.breakpoints.down('md')]: {
            marginTop: spacing.xxs,
            marginBottom: '0',
        } }),
    linkContainer: { display: 'inline-flex', flexDirection: 'column' },
    headingLine: {
        alignSelf: 'flex-start',
        marginBottom: spacing.xs,
        display: 'block',
        padding: spacing.xs,
        margin: 0,
        '&:first-child': {
            transform: 'rotate(358deg) translate(5px,5px)',
            transformOrigin: 'bottom left',
        },
    },
    newHeading: {
        alignSelf: 'flex-start',
        display: 'block',
    },
    readTime: Object.assign(Object.assign(Object.assign({ color: colors.supplementary.white }, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), { [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.none) }),
}));
export default useStyles;
